var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.54224C14.0967 7.54224 14.669 7.30039 15.091 6.86988C15.5129 6.43937 15.75 5.85547 15.75 5.24664C15.75 4.81047 15.6375 4.40874 15.4237 4.0644L13.5 0.655426L11.5763 4.0644C11.3625 4.40874 11.25 4.81047 11.25 5.24664C11.25 6.50922 12.2625 7.54224 13.5 7.54224ZM18.5963 18.9285L17.4712 17.7806L16.2562 19.0088C14.7937 20.5009 12.2288 20.5124 10.755 19.0088L9.55125 17.7806L8.325 19.0088C7.59375 19.7549 6.615 20.1681 5.58 20.1681C4.75875 20.1681 4.005 19.9041 3.375 19.4679V25.9071H23.625V19.4679C22.7812 20.0533 21.7013 20.3288 20.5425 20.0648C19.8 19.9041 19.1363 19.4794 18.5963 18.9285ZM20.25 10.9857H14.625V8.69005H12.375V10.9857H6.75C4.8825 10.9857 3.375 12.5237 3.375 14.4291V16.1967C3.375 17.4363 4.365 18.4464 5.58 18.4464C6.165 18.4464 6.7275 18.2168 7.1325 17.7921L9.54 15.3473L11.9362 17.7921C12.7687 18.6415 14.22 18.6415 15.0525 17.7921L17.46 15.3473L19.8562 17.7921C20.2725 18.2168 20.8238 18.4464 21.4088 18.4464C22.6238 18.4464 23.6138 17.4363 23.6138 16.1967V14.4291C23.625 12.5237 22.1175 10.9857 20.25 10.9857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27.5473,
    fill: "white",
    transform: "translate(0 0.655426)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.c1762fd7bc867034eb9c6be8a82c0cde.svg";
export { ForwardRef as ReactComponent };